import DotElement from "@/components/tableElements/DotElement.vue";
export default {
  name: "DottedPositionBar",
  components: {
    DotElement
  },
  props: {
    value: {
      type: [Number, null],
      required: true,
      default: 0
    },
    color: {
      type: String,
      required: true,
      default: "#312783"
    }
  },
  data() {
    return {
      numberOfDots: 10
    };
  },
  computed: {
    position() {
      if (!this.value) return 0;
      const position = Math.ceil(this.value * this.numberOfDots / 100);
      return position > this.numberOfDots ? this.numberOfDots : position;
    },
    numberOfDotsBefore() {
      if (!this.position) return 10;
      return this.position - 1;
    },
    numberOfDotsAfter() {
      if (!this.position || this.position === this.numberOfDots) return 0;
      return this.numberOfDots - this.position;
    }
  }
};